import { render, staticRenderFns } from "./matchPlay.vue?vue&type=template&id=d0579640&scoped=true"
import script from "./matchPlay.vue?vue&type=script&lang=js"
export * from "./matchPlay.vue?vue&type=script&lang=js"
import style0 from "./matchPlay.vue?vue&type=style&index=0&id=d0579640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0579640",
  null
  
)

export default component.exports